<div class="spinner-container" *ngIf="!checkLoadedResend()">
    <mat-spinner class="content-box"></mat-spinner>
</div>

<mat-card appearance="outlined" class="mat-elevation-z8" *ngIf="checkLoadedResend()">

    <div class="txt warning-message" *ngIf="!validCertificates">
        <strong>{{'historyTexts.noValidCerts' | translate}}</strong>
    </div>

    <mat-card-content class="container">
        <mat-horizontal-stepper *ngIf="validCertificates" [selectedIndex]="selectedStepIndex" linear #stepper="matHorizontalStepper" class="row">
            <ng-template matStepperIcon="done">
                <cqes-icon icon="check"></cqes-icon>
            </ng-template>
            <ng-template matStepperIcon="edit">
                <cqes-icon icon="check"></cqes-icon>
            </ng-template>
            <mat-step [completed]="signingStepCompleted" class="col-3" [editable]="isEditable">
                <div class="row">
                    <div class="col-md-7 section">
                        <div class="txt">
                            {{ 'businessTexts.documents' | translate }}
                        </div>
                        <ng-template matStepLabel>{{'businessTexts.sendDocumentsOtc' | translate }}</ng-template>
                        <div class="dropzone txt">
                            <input type="file" #fileDropRef id="fileDropRef" multiple [disabled]="isResend"
                                (change)="fileBrowseHandler($event.target.files)">
                            <label for="fileDropRef" [ngClass]="{'disabled': isResend }">
                                <cqes-icon icon="file_upload"
                                    [ngClass]="{ 'upload': !isResend, 'inactive-icon': isResend }"></cqes-icon>
                                {{ 'businessTexts.chooseFile' | translate }} {{ 'businessTexts.orDragAndDrop' | translate }}

                            </label>
                            <div class="files-list">
                                <div *ngFor="let f of files; let i = index" class="file-holder">
                                    <span *ngIf="!isResend" class="name"><strong>{{f.file.name}} </strong></span>
                                    <span *ngIf="isResend" class="name"><strong>{{f.fileName}} </strong></span>
                                    <div class="file-actions">
                                        <strong>
                                            {{f.file.size | filesize}}
                                        </strong>
                                        <cqes-icon class="file-icon" icon="description"
                                            matTooltip="{{'businessTexts.previewDocument' | translate}}"
                                            (click)="$event.preventDefault();$event.stopPropagation();viewFile(f.file)"></cqes-icon>
                                        <cqes-icon class="file-icon" icon="cancel"
                                            [ngClass]="{'inactive-action-icon': isResend }"
                                            matTooltip="{{'businessTexts.removeDocument' | translate}}"
                                            (click)="deleteFile(i)"></cqes-icon>
                                        <cqes-icon class="file-icon" icon="touch_app" *ngIf="isPdf(f)"
                                            [class.inactive-action-icon]="!isSignable(f)"
                                            matTooltip="{{'signingTexts.info.selectSignPosition' | translate}}"
                                            (click)="openPositionDialog(f, i)"></cqes-icon>
                                    </div>
                                </div>
                            </div>
                            <ng-template matStepLabel matStepperIcon="done">
                                <cqes-icon icon="check"></cqes-icon>
                            </ng-template>
                        </div>
                        <mat-error *ngIf="showValidations && !files.length" class="error">{{
                            'businessTexts.fileRequired' | translate }}</mat-error>
                        <mat-error *ngIf="showValidations && !hasSignableFile()" class="error">{{
                            'businessTexts.signableFileRequired' | translate }}</mat-error>
                    </div>

                    <div class="col-md-5">
                        <div class="txt">
                            {{ 'businessTexts.packageSettings' | translate }}
                        </div>
                        <div class="package-settings txt">
                            <mat-checkbox color="primary" [(ngModel)]="packageToArchive" [disabled]="isResend">
                                {{ 'businessTexts.packageToArchive' | translate }}
                            </mat-checkbox>
                            <br>
                            <button mat-raised-button color="accent" (click)="openPositionPanel()"
                                [disabled]="isMainPosButtonDisabled()">
                                <cqes-icon class="position-icon" icon="touch_app"></cqes-icon>
                                {{'signingTexts.info.selectSignPosition' | translate}}
                            </button>
                            <br>
                            <mat-checkbox color="primary" [(ngModel)]="visibleSignature"
                                [disabled]="isResend || !hasPdf()">
                                {{ 'signingTexts.visibleSignature' | translate }}
                            </mat-checkbox>
                             <mat-checkbox color="primary" [(ngModel)]="sendSignedDocumentsByEmail">
                                {{ 'signingTexts.sendSignedDocumentsByEmail' | translate }}
                            </mat-checkbox>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-md-12 section">
                        <button mat-raised-button color="accent" (click)="onSend()" type="button"
                            class="act-btn">{{texts.info.send }}
                        </button>
                        <button mat-raised-button color="accent" (click)="onCancel()" type="button"
                            class="act-btn">{{'settingsList.common.cancel' | translate}}
                        </button>
                    </div>
                </div>


            </mat-step>
            <mat-step class="col-3">
                <ng-template matStepLabel>{{texts.signResult}}</ng-template>
                <div class="result">
                    <div *ngIf="loading">
                        <span>
                            {{ 'businessTexts.packageSent' | translate }}
                        </span>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </div>
                    <div *ngIf="!loading">
                        <strong>
                            <span *ngIf="isSentSuccessfully">{{ 'businessTexts.documentSentSuccess' | translate }}</span>
                            <span *ngIf="!isSentSuccessfully" class="error">{{'signingTexts.signingError' |
                                translate}}</span>
                        </strong>
                    </div>
                </div>

                <mat-card-actions class="tar">
                    <button [disabled]="loading" mat-raised-button matStepperPrevious
                        (click)="onCancel()">{{'common.back'
                        | translate}}</button>
                </mat-card-actions>
            </mat-step>
        </mat-horizontal-stepper>
    </mat-card-content>
</mat-card>